import Reflux from 'reflux'
import ToolBarActions from '../actions/ToolBarActions'

var ToolBarPrintStore = Reflux.createStore(
{
	init:function(){this.listenTo(ToolBarActions.print,'print')},
    print(_value)
    {
        //this.values.push(_value);
		this.trigger(_value);
    }
});

export default ToolBarPrintStore;


// WEBPACK FOOTER //
// ./src/stores/ToolBarPrintStore.js